
import _ from "lodash";
import { projectTypes } from "constants/projectTypes";
import hedgeTypes from "constants/hedgeTypes";

import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatMonths,
  formatDate,
  formatNumberTwoDecimal,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatNumberOneDecimal,
  formatRateThreeDecimal,
  formatPrepaymentPenalty,
  formatDscr,
  formatExtensionsQualification
} from "./formatters";
//* This was misnamed. It should be called deal banner metric formatter */
const CASH_EQUITY = "f69e40d8-2c5f-43e6-99d2-873d9a9058f4";
const MARKET_VALUE = "d32d771f-1e74-4af3-8204-d98a85993e3d";
const EXPENSE_RATIO = "04c05009-a8c3-11e9-8b5f-00ff12c3b408";
const CURRENT_BALANCE = "681d83ea-2e11-11e9-ac70-0242ac140002";
const UNFUNDED_COMMITMENT = "681d843a-2e11-11e9-ac70-0242ac140002";
const CURRENT_RATE = "681d8489-2e11-11e9-ac70-0242ac140002";
const PROJECTED_RATE = "681d84db-2e11-11e9-ac70-0242ac140002";
const UPCOMING_PAYMENT = "681d8530-2e11-11e9-ac70-0242ac140002";
const MONTHS_UNTIL_MATURITY = "681d8588-2e11-11e9-ac70-0242ac140002";
const IO_REMAINING = "681d85e0-2e11-11e9-ac70-0242ac140002";
const MAX_RECOURSE = "681d8639-2e11-11e9-ac70-0242ac140002";
const AGGREGATE_RECOURSE = "c5ca6d14-9eab-11eb-b02e-98fa9bde2f84";
const DSCR = "681d8695-2e11-11e9-ac70-0242ac140002";
const DEBT_YIELD = "681d86f1-2e11-11e9-ac70-0242ac140002";
const LTV = "681d874f-2e11-11e9-ac70-0242ac140002";
const PREPAYMENT_PENALTY = "681d87af-2e11-11e9-ac70-0242ac140002";
const COVENANT_TEST_FREQUENCY = "681d8811-2e11-11e9-ac70-0242ac140002";
const DEBT_RSF = "681d8875-2e11-11e9-ac70-0242ac140002";
const DEBT_MF_UNIT = "681d88da-2e11-11e9-ac70-0242ac140002";
const PROJECTED_EXIT_DATE = "681d8941-2e11-11e9-ac70-0242ac140002";
const CAP_RATE = "681d89aa-2e11-11e9-ac70-0242ac140002";
const PROJECT_TYPE = "681d8a14-2e11-11e9-ac70-0242ac140002";
const PURCHASE_DATE = "681d8a80-2e11-11e9-ac70-0242ac140002";
const PURCHASE_PRICE = "681d8aee-2e11-11e9-ac70-0242ac140002";
const MATURITY_DATE = "681d8b5e-2e11-11e9-ac70-0242ac140002";
const EXTENDED_MATURITY_DATE = "681d8bd0-2e11-11e9-ac70-0242ac140002";
const LENDER = "681d8c43-2e11-11e9-ac70-0242ac140002";
const BORROWING_ENTITY = "681d8cb8-2e11-11e9-ac70-0242ac140002";
const HEDGE_TYPE = "681d8d2e-2e11-11e9-ac70-0242ac140002";
const HEDGE_MATURITY = "681d8da7-2e11-11e9-ac70-0242ac140002";
const HEDGE_MTM = "681d8e24-2e11-11e9-ac70-0242ac140002";
const APPRAISED_VALUE = "681d8ea1-2e11-11e9-ac70-0242ac140002";
const EQUITY = "c69ee423-aa37-11e9-8b5f-00ff12c3b408";
const CURRENT_BALANCE_SENIOR_SUPP = "c69ee880-aa37-11e9-8b5f-00ff12c3b408";
const NOI = "65ab82e1-baaf-11e9-9019-0242ac120002";
const OCCUPANCY = "74045550-baaf-11e9-9019-0242ac120002";
const ALL_IN_RATE = "f98d5a99-c2be-11e9-a4f9-00ff12c3b408";
const LTV_SUBORDINATE = "9289e6e4-c825-11e9-a4f9-00ff12c3b408";
const DEBT_YIELD_SUBORDINATE = "9289e729-c825-11e9-a4f9-00ff12c3b408";
const DSCR_LENDER_SUBORDINATE = "9289e730-c825-11e9-a4f9-00ff12c3b408";
const DSCR_ACTUAL_SUBORDINATE = "9289e735-c825-11e9-a4f9-00ff12c3b408";
const NOI_ACTUAL = "fe2a5a3e-c825-11e9-a4f9-00ff12c3b408";
const DSCR_ACTUAL = "f4db2745-c826-11e9-a4f9-00ff12c3b408";
const REFI_PROCEEDS = "8d06bbf3-8ec8-11ea-9df5-2c4d543da462";
const SUPPLEMENTAL_LOAN_PROCEEDS = "6b4c24ae-fcd8-49d4-9df7-99ede1742a22";
const REFI_CASH_OUT = "4eb3a432-68f8-4242-99f0-6610426d240c";
const ALL_IN_EFFECTIVE_RATE = "439a47b2-4a64-4bad-8df3-91f6e3d35775";
const GOOD_NEWS_MONEY_REMAINING_DOLLAR_AMOUNT = "593a308c-e248-11ea-845c-802bf905d5f8";
const GOOD_NEWS_MONEY_REMAINING_PERCENT = "4db220b3-e2f1-11ea-845c-802bf905d5f8";
const EXTENSION_QUALIFICATION = "ee41cce2-e2f4-11ea-845c-802bf905d5f8";

const DEVELOPMENT_COST = "75111970-0fa4-11eb-9711-98fa9bde2f84";
const SQUARE_FEET = "9c6969cc-1855-11eb-b24c-98fa9bde2f84";
const MF_UNITS = "9c6969c5-1855-11eb-b24c-98fa9bde2f84";
const SALES_PRICE = "9c6969bd-1855-11eb-b24c-98fa9bde2f84";
const EXIT_CAP = "9c696954-1855-11eb-b24c-98fa9bde2f84";
const CLOSING_DATE = "12042c12-186d-11eb-b24c-98fa9bde2f84";
const EXIT_DATE = "8002557f-1873-11eb-b24c-98fa9bde2f84";

const NOI_LENDER_PLUSFIFTEEN = "315d1fc3-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_LENDER_PLUSTEN = "315d1fcc-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_LENDER_PLUSFIVE = "315d1fd3-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_LENDER_MINUSFIVE = "315d1fdb-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_LENDER_MINUSTEN = "315d1fe2-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_LENDER_MINUSFIFTEEN = "315d1fe8-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_ACTUAL_PLUSFIFTEEN = "315d1ff0-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_ACTUAL_PLUSTEN = "315d1ff6-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_ACTUAL_PLUSFIVE = "315d1ffc-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_ACTUAL_MINUSFIVE = "315d2002-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_ACTUAL_MINUSTEN = "315d200a-a69f-11eb-b795-0a0ed7ec18e7";
const NOI_ACTUAL_MINUSFIFTEEN = "315d2010-a69f-11eb-b795-0a0ed7ec18e7";
const DEBT_YIELD_PLUSFIFTEEN = "50040a06-a6aa-11eb-b795-0a0ed7ec18e7";
const DEBT_YIELD_PLUSTEN = "50040a5b-a6aa-11eb-b795-0a0ed7ec18e7";
const DEBT_YIELD_PLUSFIVE = "50040a64-a6aa-11eb-b795-0a0ed7ec18e7";
const DEBT_YIELD_MINUSFIVE = "50040a6c-a6aa-11eb-b795-0a0ed7ec18e7";
const DEBT_YIELD_MINUSTEN = "50040a73-a6aa-11eb-b795-0a0ed7ec18e7";
const DEBT_YIELD_MINUSFIFTEEN = "50040a7b-a6aa-11eb-b795-0a0ed7ec18e7";

export default {
  [CASH_EQUITY]: formatCurrency,
  [MARKET_VALUE]: formatCurrency,
  [EXPENSE_RATIO]: formatRate,
  [CURRENT_BALANCE]: formatCurrency,
  [UNFUNDED_COMMITMENT]: formatCurrency,
  [CURRENT_RATE]: formatRate,
  [PROJECTED_RATE]: formatRate,
  [UPCOMING_PAYMENT]: formatCurrency,
  [MONTHS_UNTIL_MATURITY]: formatMonths,
  [IO_REMAINING]: formatMonths,
  [MAX_RECOURSE]: formatCurrency,
  [AGGREGATE_RECOURSE]: formatCurrency,
  [DSCR]: formatDscr,
  [DEBT_YIELD]: formatRate,
  [LTV]: formatRate,
  [PREPAYMENT_PENALTY]: formatPrepaymentPenalty,
  [COVENANT_TEST_FREQUENCY]: notImplemented,
  [DEBT_RSF]: formatCurrencyTwoDecimal,
  [DEBT_MF_UNIT]: formatCurrency,
  [PROJECTED_EXIT_DATE]: formatDate,
  [CAP_RATE]: formatRate,
  [PROJECT_TYPE]: formatDisplayValue,
  [PURCHASE_DATE]: formatDate,
  [PURCHASE_PRICE]: formatCurrency,
  [MATURITY_DATE]: formatDate,
  [EXTENDED_MATURITY_DATE]: formatDate,
  [LENDER]: formatDisplayValue,
  [BORROWING_ENTITY]: notImplemented,
  [HEDGE_TYPE]: formatDisplayValue,
  [HEDGE_MATURITY]: formatDate,
  [HEDGE_MTM]: formatCurrency,
  [APPRAISED_VALUE]: formatCurrency,
  [EQUITY]: formatCurrency,
  [CURRENT_BALANCE_SENIOR_SUPP]: formatCurrency,
  [NOI]: formatCurrency,
  [OCCUPANCY]: formatRate,
  [ALL_IN_RATE]: formatRate,
  [LTV_SUBORDINATE]: formatRate,
  [DEBT_YIELD_SUBORDINATE]: formatRate,
  [DSCR_LENDER_SUBORDINATE]: formatDscr,
  [DSCR_ACTUAL_SUBORDINATE]: formatDscr,
  [NOI_ACTUAL]: formatCurrency,
  [DSCR_ACTUAL]: formatDscr,
  [REFI_PROCEEDS]: formatCurrency,
  [SUPPLEMENTAL_LOAN_PROCEEDS]: formatCurrency,
  [REFI_CASH_OUT]: formatCurrency,
  [ALL_IN_EFFECTIVE_RATE]: formatRate,
  [GOOD_NEWS_MONEY_REMAINING_DOLLAR_AMOUNT]: formatCurrency,
  [GOOD_NEWS_MONEY_REMAINING_PERCENT]: formatRate,
  [EXTENSION_QUALIFICATION]: formatExtensionsQualification,
  [DEVELOPMENT_COST]: formatCurrency,
  [SQUARE_FEET]: formatInteger,
  [MF_UNITS]: formatInteger,
  [SALES_PRICE]: formatCurrency,
  [EXIT_CAP]: formatRate,
  [CLOSING_DATE]: formatDate,
  [EXIT_DATE]: formatDate,
  [NOI_LENDER_PLUSFIFTEEN]: formatRate,
  [NOI_LENDER_PLUSTEN]: formatRate,
  [NOI_LENDER_PLUSFIVE]: formatRate,
  [NOI_LENDER_MINUSFIVE]: formatRate,
  [NOI_LENDER_MINUSTEN]: formatRate,
  [NOI_LENDER_MINUSFIFTEEN]: formatRate,
  [NOI_ACTUAL_PLUSFIFTEEN]: formatRate,
  [NOI_ACTUAL_PLUSTEN]: formatRate,
  [NOI_ACTUAL_PLUSFIVE]: formatRate,
  [NOI_ACTUAL_MINUSFIVE]: formatRate,
  [NOI_ACTUAL_MINUSTEN]: formatRate,
  [NOI_ACTUAL_MINUSFIFTEEN]: formatRate,
  [DEBT_YIELD_PLUSFIFTEEN]: formatRate,
  [DEBT_YIELD_PLUSTEN]: formatRate,
  [DEBT_YIELD_PLUSFIVE]: formatRate,
  [DEBT_YIELD_MINUSFIVE]: formatRate,
  [DEBT_YIELD_MINUSTEN]: formatRate,
  [DEBT_YIELD_MINUSFIFTEEN]: formatRate
};
